type SheetSize = "small" | "large" | "extraLarge";

// Uses data-[side] selector to match primitive specificity so tailwind-merge
// can override the default sm:max-w-sm from the primitive.
export const SIZE_CLASS_MAP: Record<SheetSize, string> = {
  small: "data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm",
  large: "data-[side=left]:sm:max-w-lg data-[side=right]:sm:max-w-lg",
  extraLarge: "data-[side=left]:sm:max-w-2xl data-[side=right]:sm:max-w-2xl",
};
